import { render } from "./SidebarMenuItemIcon.vue?vue&type=template&id=571e6d21&ts=true"
import script from "./SidebarMenuItemIcon.vue?vue&type=script&lang=ts"
export * from "./SidebarMenuItemIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__